// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"207c9744","380":"11ae247a","382":"140125ac","418":"7ab80acb","573":"981851e9","791":"d6e2f44c"}[chunkId] + ".chunk.css";
};